module.exports = __WEBPACK_EXTERNAL_MODULE_53__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","subMonths"],"commonjs":"date-fns/sub_months/index","commonjs2":"date-fns/sub_months/index","amd":"date-fns/sub_months/index"}
// module id = 53
// module chunks = 0